import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {auth, endpoints} from 'main/tools';
import GoalSubnav from 'main/containers/performance_goals/GoalSubnav';
import {Layout} from 'shared/components';
import {GoalList} from 'main/containers/performance_goals/components';

const MyGoalsContainer = observer(({match, history, scope}) => {
  return (
    <div>
      <GoalSubnav scope={scope} />
      <Layout>
        <GoalList
          {...{match, history}}
          canCreateGoals={true}
          title={t('goals.My Goals')}
          endpoint={endpoints.PERFORMANCE_GOALS.GOALS_FOR_EMPLOYEE.with(auth.employee.id)}
        />
      </Layout>
    </div>
  );
});

export default MyGoalsContainer;
